"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopy = exports.filterRootData = exports.buildKeyMap = exports.checkParent = exports.onCheck = exports.checkChildren = exports.checkParentCheckAll = exports.filter = exports.walk = void 0;
var walk = function (keyToNodeMap, children, data) {
    var newKeyToNodeMap = keyToNodeMap;
    children.forEach(function (item) {
        var newItem = item;
        newItem.parent = data;
        if (keyToNodeMap) {
            newKeyToNodeMap[newItem.key] = newItem;
        }
        if (newItem.children && newItem.children.length > 0) {
            (0, exports.walk)(newKeyToNodeMap, newItem.children, newItem);
        }
    });
};
exports.walk = walk;
/**
 * 过滤父类计算
 * @param callback
 * @param children
 */
var filterParentClassify = function (callback, children) {
    if (Array.isArray(children) && children.length)
        return;
    callback();
};
/**
 * 返回指定格式name, key
 * @param data
 */
var filter = function (data) {
    var children = data.children;
    var result = [];
    var resultLen = 0;
    var countNun = 0;
    var dg = function (val, parent) {
        var indeterminate = false;
        val.forEach(function (item) {
            var _a;
            var children = (item || {}).children;
            var isChecked = item.checked && !item.disabled;
            filterParentClassify(function () {
                countNun = countNun + 1;
            }, children);
            if (isChecked) {
                filterParentClassify(function () {
                    resultLen = resultLen + 1;
                }, children);
                indeterminate = true;
            }
            var len = ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) || 0;
            if (item.children && len > 0) {
                dg(item.children, item);
            }
        });
        // eslint-disable-next-line no-param-reassign
        parent.indeterminate = indeterminate;
    };
    if (children) {
        dg(children, data);
        collectData(children, data, result);
    }
    return {
        result: result,
        resultLen: resultLen,
        countNun: countNun,
    };
};
exports.filter = filter;
/**
 * 获取返回数据
 * @param val
 * @param parent
 * @param res
 */
var collectData = function (val, parent, res) {
    val.forEach(function (item) {
        var _a;
        var isChecked = item.checked && !item.disabled;
        if (item.indeterminate || isChecked) {
            res.push({
                key: item.key,
                name: item.name,
            });
        }
        var len = ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) || 0;
        var spliceData = res[res.length - 1];
        if (item.children && len > 0) {
            if (spliceData && !spliceData.children) {
                spliceData.children = [];
            }
            var _b = (spliceData || {}).children, children1 = _b === void 0 ? [] : _b;
            collectData(item.children, item, children1);
        }
    });
};
/**
 * 遍历数据确认父类状态
 * @param parent
 */
var checkParentCheckAll = function (parent) {
    var _loop_1 = function () {
        if (parent.children) {
            var newParent = parent;
            var parentIndeterminate_1 = false;
            newParent.checked = parent.children.every(function (item) {
                if (!parentIndeterminate_1 && (item.checked || item.disabled)) {
                    parentIndeterminate_1 = true;
                }
                return item.checked || item.disabled;
            });
            newParent.indeterminate = parentIndeterminate_1;
            // eslint-disable-next-line no-param-reassign
            parent = parent.parent;
        }
    };
    while (parent) {
        _loop_1();
    }
};
exports.checkParentCheckAll = checkParentCheckAll;
/**
 * 子类操作
 * @param children
 * @param checked
 */
var checkChildren = function (children, checked) {
    children === null || children === void 0 ? void 0 : children.forEach(function (item) {
        if (!item.disabled) {
            var newItems = item;
            newItems.checked = checked;
            (0, exports.checkChildren)(newItems.children, checked);
        }
    });
};
exports.checkChildren = checkChildren;
/**
 * 选择状态操作
 * @param keyToNodeMap
 * @param key
 */
var onCheck = function (keyToNodeMap, key) {
    if (keyToNodeMap) {
        var data = keyToNodeMap[String(key)];
        if (data) {
            data.checked = !data.checked;
            if (data.checked) {
                (0, exports.checkChildren)(data.children || [], true);
                (0, exports.checkParentCheckAll)(data.parent);
            }
            else {
                (0, exports.checkChildren)(data.children || [], false);
                (0, exports.checkParent)(data.parent, false);
            }
        }
    }
};
exports.onCheck = onCheck;
/**
 * 父类操作
 * @param parent
 * @param checked
 */
var checkParent = function (parent, checked) {
    while (parent) {
        var newParents = parent;
        newParents.checked = checked;
        // eslint-disable-next-line no-param-reassign
        parent = parent.parent;
    }
};
exports.checkParent = checkParent;
/**
 * 合成key
 * @param data
 * @param onCallback
 */
var buildKeyMap = function (data, onCallback) {
    if (!data || !data.key)
        return;
    var keyToNodeMap = {};
    keyToNodeMap[data.key] = data;
    if (data.children && data.children.length > 0) {
        (0, exports.walk)(keyToNodeMap, data.children, data);
    }
    onCallback(data, keyToNodeMap);
};
exports.buildKeyMap = buildKeyMap;
/**
 * 修改数据新增childRoot 跟节点
 * @param data
 * @param mainKeys
 */
var filterRootData = function (data, mainKeys) {
    var dataLen = (data === null || data === void 0 ? void 0 : data.length) || 0;
    if (Array.isArray(data) && dataLen > 0) {
        return {
            name: 'name',
            key: 'key',
            type: 'folder',
            collapsed: false,
            children: data.map(function (item) {
                var key = item.key;
                mainKeys.push(String(key));
                return __assign(__assign({}, item), { childRoot: true });
            }),
        };
    }
    return data[0];
};
exports.filterRootData = filterRootData;
var deepCopy = function (target, map) {
    if (!target || typeof target !== 'object') {
        return null;
    }
    if (!map) {
        // eslint-disable-next-line no-param-reassign
        map = new Map();
        map.set(target, true);
    }
    var result = Array.isArray(target) ? [] : {};
    Object.keys(target).forEach(function (property) {
        if (typeof target[property] !== 'object') {
            result[property] = target[property];
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            if (map === null || map === void 0 ? void 0 : map.has(target[property])) {
                result[property] = undefined;
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                map === null || map === void 0 ? void 0 : map.set(target[property], true);
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                result[property] = (0, exports.deepCopy)(target[property], map);
            }
        }
    });
    return result;
};
exports.deepCopy = deepCopy;
//# sourceMappingURL=utils.js.map